<template>
  <v-app class="grey lighten-4" >
    <Navbar />

    <v-content class="grey lighten-4">
      <router-view></router-view>
    </v-content>
    
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
export default {
  components: { Navbar },
  name: 'App',
  data () {
    return {
      
    }
  }
}
</script>